import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { AuthService } from '@/app/features/auth/services/auth.service';
import { LanguageFacade } from '@/app/core/language/facades/language.facade';
import { CountryFacade } from '@/app/core/country/facades/country.facade';
import { environment } from '@/environments/environment';

/**
 * Endpoints que aceptan el header Country-Id.
 * Añade aquí cualquier URL adicional cuando sea necesario.
 */
const COUNTRY_ID_URLS: string[] = [
  `${environment.userApiBaseUrl}/address`,
  `${environment.marketplaceApiBaseUrl}/cart/product-information`,
  `${environment.marketplaceApiBaseUrl}/checkout/preview`,
  `${environment.marketplaceApiBaseUrl}/checkout/payment`,
  `${environment.marketplaceApiBaseUrl}/quotation/generate-quotation-order`,
  // ms_nd_orders_new: order-service (list/detail/detail-timeline/cancel/update*), order-status,
  // shipping-types, alert-types, y su propio checkout (preview/insured_value/payment) — todo
  // el servicio acepta Country-Id, así que se whitelistea el base completo.
  environment.ordersNewApiBaseUrl,
];

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const language = inject(LanguageFacade);
  const country = inject(CountryFacade);
  const token = auth.token;

  let headers = req.headers
    .set('X-App-Version', '1.0')
    .set('X-Requested-With', 'XMLHttpRequest')
    .set('Accept-Language', language.languageKey());

  if (COUNTRY_ID_URLS.some((url) => req.url.startsWith(url))) {
    headers = headers.set('Country-Id', String(country.countryId()));
  }

  if (token) {
    headers = headers.set('Authorization', `Bearer ${token}`);
  }

  return next(req.clone({ headers }));
};
